import { notifyBugsnag } from '../bugsnag';

export const reportAnalyticsError = (message: string, error: unknown) => {
    const analyticsError = error instanceof Error ? error : new Error(String(error));
    console.error(message, analyticsError);
    notifyBugsnag(analyticsError);
};
